import { Divider } from '@magnetic/divider';
import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const NavDivider = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(Divider, {
  className: "mds-nav-divider",
  ...props
}), "NavDivider");

export { NavDivider };
//# sourceMappingURL=nav-divider.js.map
